import React from 'react';
import './CaseStudies.css';

const CaseStudies = () => {
  const caseStudies = [
      {
        title: 'Enhancing Job Interview Skills with AI',
        description: 
          'SocialCompass utilizes AI-driven virtual agents to simulate job interviews, aiding individuals in improving their self-presentation and social interaction skills. Studies have shown that such AI-based coaching environments can effectively support learners at risk of social exclusion by providing realistic interview practice scenarios.',
        img: 'Case Studies/CaseStudies_Human.jpg',
        link: 'https://link.springer.com/chapter/10.1007/978-3-662-66866-5_4',
      },
      {
        title: 'Exploring Human-Plant Interaction through AI',
        description: 
          'Biolingo employs AI technology to analyze human gestures and their impact on plant behavior, advancing the understanding of human-plant communication. Research indicates that AI can effectively track eurythmic human–plant interactions, providing insights into how plants perceive human gestures.',
        img: 'Case Studies/CaseStudies_Plants.jpg',
        link: 'https://www.mdpi.com/2313-7673/9/5/290',
      },
      {
        title: 'Real-Time Emotional Feedback Improves Virtual Teamwork',
        description: 
          'This study investigates the impact of real-time emotional feedback on the quality of teamwork over videoconferencing. Using a virtual mirror based on facial and voice emotion recognition, 28 teams (84 participants) collaborated over Zoom. Analysis revealed that fewer interruptions, higher vocal arousal, and greater expressed happiness enhanced team performance.',
        img: 'Case Studies/CaseStudies_Human.jpg',
        link: 'https://www.mdpi.com/2076-3417/14/13/5659',
      },      

  ];

  return (
    <section id="case-studies" className="case-studies-section">
      <h2 className="case-studies-title">Case Studies</h2>
      <div className="case-studies-grid">
        {caseStudies.map((study, index) => (
          <div key={index} className="case-card">
            <img
              src={study.img}
              alt={study.title}
              className="case-img"
            />
            <h3 className="case-title">{study.title}</h3>
            <p className="case-description">{study.description}</p>
            <a href={study.link} className="case-link">
              Read More
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CaseStudies;
